// React
import React, { useState, useRef, useEffect } from 'react';

// Styles
import styles from './MainNavItem.module.scss';

// Third party
import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';

// Material UI
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

// Services
import { logoutUser } from '../../../services/auth';

import {
  Popper,
  Grow,
  Paper,
  List,
  ClickAwayListener,
  ListItem,
  ListItemText,
  Link
} from '@material-ui/core';

// This component
export default function MainNavItem({
  label,
  to,
  logout,
  items,
  isDrawerMenu,
  closeDrawer
}) {
  // Anchor (helper for submenu/dropdown)
  const anchor = useRef(null);

  // ...
  const [open, setOpen] = useState(false);

  // Handle itemssubmenu/dropdown toggle
  const handleToggle = (event) => {
    setOpen((prevOpen) => !prevOpen);
  };

  // Handle submenu/dropdown close
  const handleClose = (event) => {
    if (anchor.current && anchor.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  // Return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchor.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  // Handle logout
  const handleLogout = (event) => {
    event.preventDefault();
    logoutUser();
  };

  const handleLinkClick = (isLogout, isNestedHandling, isDrawerHandling) => (
    event
  ) => {
    if (isLogout) {
      handleLogout(event);
    }

    if (isNestedHandling) {
      handleToggle(event);
    }

    if (isDrawerHandling && !isNestedHandling) {
      closeDrawer(event);
    }
  };

  const nestedList = items ? (
    <List className={styles['nested-list']}>
      {items &&
        items.map((item, i) => {
          return (
            <ListItem key={i} className={styles['nested-list-item']}>
              <Link
                className={styles['list-item-link']}
                underline="none"
                component={RouterLink}
                exact={true}
                to={item.to}
                onClick={handleLinkClick(logout, items, isDrawerMenu)}>
                <ListItemText
                  className={styles['list-item-link-text']}
                  disableTypography={true}>
                  {item.label}
                </ListItemText>
              </Link>
            </ListItem>
          );
        })}
    </List>
  ) : null;

  // JSX
  return (
    <ListItem className={styles['list-item']}>
      <Link
        className={`${styles['list-item-link']} ${
          logout ? styles['list-item-link--gray'] : ''
        }`}
        underline="none"
        component={RouterLink}
        exact={true}
        activeClassName={items || logout ? null : styles.selected}
        to={to}
        onClick={handleLinkClick(logout, items, isDrawerMenu)}
        aria-haspopup={items ? true : false}
        ref={anchor}>
        <ListItemText
          className={styles['list-item-link-text']}
          disableTypography={true}>
          {label}
        </ListItemText>
        {items &&
          (open ? (
            <KeyboardArrowUpIcon
              classes={{ root: styles['list-item-link-icon'] }}
            />
          ) : (
            <KeyboardArrowDownIcon
              classes={{ root: styles['list-item-link-icon'] }}
            />
          ))}
      </Link>

      {(() => {
        if (items) {
          if (isDrawerMenu) {
            return (
              <div
                className={`${styles['nested-list-wrapper']} ${
                  open ? styles['nested-list-wrapper--open'] : ''
                }`}>
                {nestedList}
              </div>
            );
          } else {
            return (
              <Popper
                open={open}
                anchorEl={anchor.current}
                role={undefined}
                placement={'bottom-start'}
                className={styles['nested-list-popper']}
                transition
                disablePortal>
                {({ TransitionProps, placement }) => (
                  <Grow {...TransitionProps}>
                    <Paper
                      square
                      elevation={0}
                      className={styles['nested-list-paper']}>
                      <ClickAwayListener onClickAway={handleClose}>
                        {nestedList}
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            );
          }
        }
      })()}
    </ListItem>
  );
}

// Properties
MainNavItem.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired
};
